"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serviceMethodConstants = void 0;
const serviceMethodConstants = exports.serviceMethodConstants = {
  // Mine Sites
  baseURL: 'https://apis.apps.weir/iamservice/',
  activities: 'https://customer.staging.weir/api/identity/iamservice/Users/Activities',
  userRolesList: 'applications/<ApplicationObjectId>/role-assignments',
  businessEntitylist: 'applications/<ApplicationObjectId>/business-entities?sourceSystemName=<SourceSystemName>',
  getUsersForSelectedBusinessEntityURL: 'applications/<ApplicationObjectId>/business-entities/<BusinessEntityObjectId>/users',
  updateAppRoleForBusinessEntity: 'applications/<ApplicationObjectId>/roles/<ApplicationRoleObjectId>/business-entities/<BusinessEntityObjectId>/users/<UserObjectId>',
  getNavigations: 'applications/<ApplicationObjectId>/navigations',
  getUserActivity: 'applications/<applicationObjectId>/users/<userObjectId>/sign-ins',
  getAssignableUsers: 'applications/<applicationObjectId>/assignable-users',
  sendInviteUrl: 'applications/<applicationObjectId>/roles/<ApplicationRoleObjectId>/business-entities/<BusinessEntityObjectId>/users/<UserEmail>',
  fetchMineSiteInfo: 'applications/<applicationObjectId>/users/<userObjectId>/source-systems/<sourceSystemName>',
  // Access Requests
  getCompletedAccessRequests: '/applications/{appObjectId}/access-requests?returnReviewedRequests=true',
  approveRejectAccessRequests: '/applications/{appObjectId}/access-requests',
  pendingApplicationAccessRequests: '/applications/{appObjectId}/access-requests?returnReviewedRequests=false',
  accessRequestRoles: '/applications/{appObjectId}/access-request/roles',
  applicationBusinessEntities: '/applications/{appObjectId}/configured-business-entities',
  sharedApisBaseUrl: 'https://apis.apps.weir/iamservice'
};